var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.dialogPlayground
      ? _c("div", { staticClass: "playground-box" }, [
          _c("div", { staticClass: "playground-content" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c("div", { staticStyle: { flex: "1" } }),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    cursor: "pointer",
                    "font-weight": "bolder",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialogPlayground = false
                    },
                  },
                },
                [_vm._v("\n          X\n        ")]
              ),
            ]),
            _c("div", { staticClass: "box-border" }, [
              _c("div", [
                _c("h3", [_vm._v("Playground de Funcionalidades")]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            Client Key *\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.clientKey,
                        expression: "clientKey",
                      },
                    ],
                    attrs: { placeholder: "Client Key *" },
                    domProps: { value: _vm.clientKey },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.clientKey = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            idForm *\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.idForm,
                        expression: "idForm",
                      },
                    ],
                    attrs: { placeholder: "idForm *" },
                    domProps: { value: _vm.idForm },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.idForm = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            idFormData\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.idFormData,
                        expression: "idFormData",
                      },
                    ],
                    attrs: { placeholder: "idFormData" },
                    domProps: { value: _vm.idFormData },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.idFormData = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            corPrimaria\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.corPrimaria,
                        expression: "corPrimaria",
                      },
                    ],
                    attrs: { placeholder: "#0075EA" },
                    domProps: { value: _vm.corPrimaria },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.corPrimaria = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            JSON\n            "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.json,
                        expression: "json",
                      },
                    ],
                    staticStyle: { width: "300px", height: "300px" },
                    domProps: { value: _vm.json },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.json = $event.target.value
                      },
                    },
                  }),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _vm._v("\n            readOnly\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.readOnly,
                        expression: "readOnly",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.readOnly)
                        ? _vm._i(_vm.readOnly, null) > -1
                        : _vm.readOnly,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.readOnly,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.readOnly = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.readOnly = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.readOnly = $$c
                        }
                      },
                    },
                  }),
                ]),
                _vm.readOnly
                  ? _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                      _vm._v(
                        "\n            showOnly (-1 para exibir todos\n            "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.showOnly,
                            expression: "showOnly",
                          },
                        ],
                        attrs: { type: "number" },
                        domProps: { value: _vm.showOnly },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.showOnly = $event.target.value
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
                  _c(
                    "button",
                    { attrs: { size: "mini" }, on: { click: _vm.abrirForm } },
                    [_vm._v("\n              Abrir Formulário\n            ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "playground-btn", on: { click: _vm.abrirCfg } }, [
      _vm._v("\n    cfg\n  "),
    ]),
    _vm.renderForm
      ? _c(
          "div",
          {
            staticStyle: {
              "max-width": "1100px",
              margin: "0 auto",
              border: "1px solid #cccccc",
            },
          },
          [_c("router-view")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }